import React, { useEffect } from 'react';
import { useCart } from '../context/CartContext';
import './PaymentResult.css';

const PaymentSuccess = () => {
  const { clearCart } = useCart();

  useEffect(() => {
    // Limpiar carrito al confirmar pago exitoso
    clearCart();
  }, [clearCart]);

  return (
    <div className="payment-result-container success">
      <div className="payment-result-content">
        <div className="payment-icon success-icon">✓</div>
        <h1 className="payment-title">¡PAGO EXITOSO!</h1>
        <p className="payment-message">
          Tu compra ha sido procesada correctamente.
        </p>
        <div className="payment-details">
          <p>Recibirás un email de confirmación en breve con los detalles de tu pedido.</p>
          <p>También te contactaremos por WhatsApp para coordinar la entrega.</p>
        </div>
        <div className="payment-actions">
          <a href="/" className="btn-volver-inicio">VOLVER AL INICIO</a>
          <a href="/#tienda" className="btn-seguir-comprando">SEGUIR COMPRANDO</a>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
